import styled from "styled-components";

import { colors } from "../../consts";

import { WrapperContainer } from "../../components";
import { InputContainer, InputWrapper } from "../Input/styled";
import { FilterDropdownOptionsList } from "./DropdownOptions/styled";
import { IconButtonStyled } from "../Buttons/styled";

export const FiltersDropdownWrapper = styled(WrapperContainer)`
  input {
    cursor: text;

    &::selection {
      background-color: transparent;
    }
  }

  > div {
    cursor: ${(props) => (props?.disabled ? "default" : "pointer")};
    pointer-events: ${(props) => (props?.disabled ? "none" : "all")};
    background-color: ${colors.WHITE};
  }

  div:first-child {
    border-radius: 16px;
  }

  & ${FilterDropdownOptionsList} {
    top: -292px;
    transform-origin: bottom center;
  }
`;

export const FiltersInputContainer = styled(InputContainer)`
  input {
    padding-left: 42px;
    padding-right: 32px;
  }
`;

export const FiltersInputWrapper = styled(InputWrapper)`
  > ${IconButtonStyled} {
    position: absolute;
    right: 20px;
  }
`;

export const CalendarIconWrapper = styled.div`
  position: absolute;
  left: 15px;
`;

export const FiltersTitle = styled.label`
  display: block;

  font-size: 14px;
  line-height: 14px;
  font-weight: 500;

  color: ${colors.RAISIN_100};

  margin-bottom: 8px;
`;
